
import { addSendMailToForm } from  '../../../layouts/general/sendMail';


let contactModalManager = {
    open: true,
    openCloseModal: function(modal) {
        this.open = !this.open;
        if(this.open) {
            modal.style.visibility = 'hidden';
            modal.style.opacity = '0';
            this.domElements.body.classList.remove('mcl-modal-contact-open');
        } else {
            modal.style.visibility = 'visible';
            modal.style.opacity = '1';
            this.domElements.body.classList.add('mcl-modal-contact-open');
        }
    },
    domElements : {
        openFormButtons : document.querySelectorAll('.mcl-open-form-button'),
        formModal : document.querySelector('#mcl-modal-container'),
        overlay : document.querySelector('#mcl-overlay'),
        form : document.querySelector('#mcl-contact-us-form'),
        closeBtn : document.querySelector('.mcl-service-modal-close'),
        referencePersonInput : document.querySelector('#mcl-reference-person-input'),
        companyInput : document.querySelector('#mcl-company-input'),
        emailInput : document.querySelector('#mcl-email-input'),
        phoneInput : document.querySelector('#mcl-phone-input'),
        responseArea : document.querySelector('.mcl-form-result-info'),
        body : document.body
    },
    formData : {}
};


(function() {
    /**
     * Add open/close event
     */
    if(contactModalManager.domElements.closeBtn) {
        contactModalManager.domElements.closeBtn.addEventListener('click', () => {
            contactModalManager.openCloseModal(contactModalManager.domElements.formModal);
        });
    }

    if(contactModalManager.domElements.overlay) {
        contactModalManager.domElements.overlay.addEventListener('click', () => {
            contactModalManager.openCloseModal(contactModalManager.domElements.formModal);
        });
    }

    /**
     * Add open event to all the action buttons in page
     */
    if(contactModalManager.domElements.openFormButtons) {
        Array.prototype.forEach.call(contactModalManager.domElements.openFormButtons, (button) => {
            button.addEventListener('click', () => {
                contactModalManager.openCloseModal(contactModalManager.domElements.formModal);
            });
        });
    }

    /**
     * Get data from form and send by email
     */
    if(contactModalManager.domElements.form) {
        contactModalManager.domElements.form.addEventListener('submit', (e) => {
            e.preventDefault();

            contactModalManager.formData.referencePerson = contactModalManager.domElements.referencePersonInput.value;
            contactModalManager.formData.company = contactModalManager.domElements.companyInput.value;
            contactModalManager.formData.email = contactModalManager.domElements.emailInput.value;
            contactModalManager.formData.phone = contactModalManager.domElements.phoneInput.value;
        })
        addSendMailToForm('mcl-contact-us-form', contactModalManager.domElements.responseArea);
    }

})();



// WEBPACK FOOTER //
// ./src/components/templates/even-odd-service/even-odd-service.js